import { loadCustomerSegments } from './customerSegment';
import { loadTestStatuses } from './testStatus';
import { loadPortfolioTemplates } from './portfolioTemplate';
import { loadDocumentTypes } from './documentTypes';
import { loadBmcBlocks } from './bmcBlocks';
import { loadTestTypes } from './testTypes';
import { loadChatGroups } from './chatGroups';
import { setMomentLocale } from './moment';
import { loadCostPriceOptions } from './costPriceOptions';
import { loadUserRoles } from './userRoles';

export const buildFactories = (locales) => {
  loadCustomerSegments(locales);
  loadTestStatuses(locales);
  loadPortfolioTemplates(locales);
  loadDocumentTypes(locales);
  loadBmcBlocks(locales);
  loadTestTypes(locales);
  loadChatGroups(locales);
  setMomentLocale(locales);
  loadCostPriceOptions(locales);
  loadUserRoles(locales);
};
